import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserTaleRole } from "@/redux/reducers/auth";
import { saveRolesToStorage } from "@/utils/roleStorage";
import authService from "@services/auth";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";

function OAuthCallback() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        console.log("[OAuthCallback] mounted, search:", window.location.search);
        const error = searchParams.get("error");
        if (error) {
            console.log("[OAuthCallback] BRANCH A - error param:", error);
            navigate("/login", { state: { oauthError: decodeURIComponent(error) }, replace: true });
            return;
        }
        const accessToken = searchParams.get("access_token");
        const refreshToken = searchParams.get("refresh_token");
        console.log("[OAuthCallback] accessToken:", accessToken ? accessToken.slice(0, 20) + "..." : null);
        if (!accessToken) {
            console.log("[OAuthCallback] BRANCH B - no accessToken");
            navigate("/login", { state: { oauthError: "No token received from server." }, replace: true });
            return;
        }
        localStorage.setItem("access_token", accessToken);
        if (refreshToken) localStorage.setItem("refresh_token", refreshToken);
        localStorage.setItem("auth_type", "local");

        let userData;
        try {
            userData = authService.getUserFromToken();
        } catch (e) {
            console.log("[OAuthCallback] getUserFromToken THREW:", e);
        }
        console.log("[OAuthCallback] userData:", userData);
        if (!userData) {
            console.log("[OAuthCallback] BRANCH C - userData falsy");
            navigate("/login", { state: { oauthError: "Failed to parse user session." }, replace: true });
            return;
        }
        console.log("[OAuthCallback] SUCCESS, navigating to app");

        localStorage.setItem("user", JSON.stringify(userData));

        const roles = userData.roles || [userData.userType];
        const taleRole = getUserTaleRole(roles);
        saveRolesToStorage(roles, taleRole);

        // Full-page redirect so App.js re-initialises from localStorage (avoids
        // the race where ProtectedRoutes renders before Redux receives the user).
        window.location.replace(taleRole === "admin" ? "/admin" : "/");
    }, [searchParams, navigate]);

    return <TaleLoadingFallback />;
}

export default OAuthCallback;















